import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../api.js'
import { Card, Field, Alert } from '../lib.jsx'

export default function Projects() {
  const nav = useNavigate()
  const [projects, setProjects] = useState([])
  const [templates, setTemplates] = useState([])
  const [name, setName] = useState('')
  const [templateId, setTemplateId] = useState('')
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)

  const load = () => {
    api.projects().then(setProjects).catch(e => setErr(e.message))
    api.templates().then(ts => setTemplates(ts.filter(t => t.status === 'published'))).catch(() => {})
  }
  useEffect(load, [])

  const create = async (e) => {
    e.preventDefault()
    if (!templateId) return
    setErr(''); setBusy(true)
    try {
      const p = await api.createProject({ name: name || 'Nowy projekt', template_id: templateId })
      nav(`/projects/${p.id}`)
    } catch (e) { setErr(e.message) } finally { setBusy(false) }
  }

  const duplicate = async (id) => {
    try { const d = await api.duplicateProject(id); load(); nav(`/projects/${d.id}`) }
    catch (e) { setErr(e.message) }
  }

  return (
    <>
      <div className="topbar"><div><h1>Projekty</h1>
        <div className="sub">Twórz dokumenty i prezentacje na podstawie opublikowanych szablonów.</div></div></div>
      <div className="content grid grid-2" style={{ alignItems: 'start' }}>
        <Card title="Nowy projekt">
          <Alert kind="err">{err}</Alert>
          {templates.length === 0 ? (
            <div className="empty">Brak opublikowanych szablonów. {templates.length === 0 && 'Poproś administratora o dodanie/opublikowanie szablonu.'}</div>
          ) : (
            <form onSubmit={create}>
              <Field label="Nazwa projektu">
                <input value={name} onChange={e => setName(e.target.value)} placeholder="np. Raport Q1 2026" />
              </Field>
              <Field label="Szablon">
                <select value={templateId} onChange={e => setTemplateId(e.target.value)}>
                  <option value="">— wybierz szablon —</option>
                  {templates.map(t => <option key={t.id} value={t.id}>{t.name} ({t.document_type}, {t.page_size})</option>)}
                </select>
              </Field>
              <button className="btn btn-primary" disabled={busy || !templateId}>{busy ? 'Tworzenie…' : 'Utwórz projekt'}</button>
            </form>
          )}
        </Card>

        <Card title="Twoje projekty" desc={`${projects.length} łącznie (własne + udostępnione)`}>
          {projects.length === 0 ? <div className="empty">Brak projektów — utwórz pierwszy po lewej.</div> : (
            <table>
              <thead><tr><th>Nazwa</th><th>Status</th><th>Aktualizacja</th><th /></tr></thead>
              <tbody>
                {projects.map(p => (
                  <tr key={p.id}>
                    <td><a onClick={() => nav(`/projects/${p.id}`)} style={{ cursor: 'pointer', fontWeight: 700 }}>{p.name || '(bez nazwy)'}</a></td>
                    <td><span className="pill">{p.status}</span></td>
                    <td className="muted small">{new Date(p.updated_at).toLocaleString('pl-PL')}</td>
                    <td><button className="btn btn-sm btn-ghost" onClick={() => duplicate(p.id)}>Duplikuj</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Card>
      </div>
    </>
  )
}
